  /**
   *  Module
   *
   * Zawiera definicje modeli bez prefiksu "Lsn"
   */
  angular.module('lsnBase.deprecated.models', ['lsnBase.models']);